import { FAQ, Testimonial, University } from "@interfaces/misc"
import MiscRepositories from "@repositories/misc.repositories"
import { Result } from "@services/result"

interface LinkResponse {
  status: string
  link: {
    id: number
    title: string
    hash: string
    alias: string
    long_url: string
    short_url: string
    disabled: false
    expires_at: Date
    description: string
    type: string
    clicks_count: number
    expiration_clicks: number
    utm: string
    has_password: boolean
  }
}

export default class MiscServices extends MiscRepositories {
  async getTestimonials() {
    try {
      const res = await this.getRawTestimonials()

      // return Result.ok<Testimonial[]>(dummyTesti)

      // const response = await this._getResponse<Testimonial[]>(res)
      //
      // const { error, result } = response
      //
      // if (error) {
      //   return Result.fail<Testimonial[]>()
      // }
      //
      // return Result.ok<Testimonial[]>(result)
    } catch (e: any) {
      return Result.fail<Testimonial[]>()
    }
  }

  async getFaqs() {
    try {
      const res = await this.getRawFAQs()
      const response = await this._getResponse<FAQ[]>(res)

      const { error, result } = response

      if (error) {
        return Result.fail<FAQ[]>()
      }

      return Result.ok<FAQ[]>(result)
    } catch (e: any) {
      return Result.fail<FAQ[]>()
    }
  }

  async getUniversities() {
    try {
      const res = await this.getRawUniversities()
      const response = await this._getResponse<University[]>(res)

      const { error, result } = response

      if (error) {
        return Result.fail<University[]>()
      }

      return Result.ok<University[]>(result)
    } catch (e: any) {
      return Result.fail<University[]>()
    }
  }

  async getShareLink(slug: string) {
    try {
      const res = await this.getRawShareLink({
        long_url: `${
          process.env.API_ENDPOINT || process.env.HARISENIN_API_ENDPOINT
        }/risebinar/${slug}`,
        type: "direct",
        active: true,
      })

      if (res.ok) {
        const body = (await res.json()) as LinkResponse
        return Result.ok<string>(body.link.short_url)
      } else {
        return Result.fail<string>()
      }
    } catch (e) {
      return Result.fail<string>()
    }
  }
}
